export const checkRefreshing: any = (store: any) => (next: any) => (action: any) => {
  if (!store.getState().session.isRefreshing || action.type === '@action.session.setRefreshing') {
    return next(action);
  }
};
